<form class="void-payment-form astral-stack-m" [formGroup]="form" (ngSubmit)="onSubmit()">
  <h4>{{ 'INCORRECT_PAYMENT.VOID' | translate }}</h4>
  <app-information-block [text]="'INCORRECT_PAYMENT.VOID_DESCRIPTION' | translate"></app-information-block>
  <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
    <astral-checkbox [control]="changeAccountingControl"></astral-checkbox>
    @if (changeAccountingControl.value) {
      <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
        <astral-date-picker [control]="transactionDateControl"></astral-date-picker>
        <astral-input
          class="astral-grid-span-2"
          [control]="form.controls['verificationDescription']"
          [helpText]="'INVOICE.HELP_TEXT.CREDIT_ACCOUNTING_DESCRIPTION'"
        ></astral-input>
      </astral-layout-group>
    }
    @if (showAccountingClosedDate) {
      <app-information-block
        [text]="'INCORRECT_PAYMENT.ACCOUNTING_CLOSED' | translate: { date: dataContext.companyAccountingClosedToDate }"
      ></app-information-block>
    }
  </section>
  <div class="astral-form-actions">
    <astral-button variant="primary" type="submit" [disabled]="isSubmitting" label="OK"></astral-button>
    <astral-button variant="secondary" type="button" labelKey="CANCEL_BTN" (click)="cancel()"></astral-button>
  </div>
</form>
